import axios from 'axios';

const instance = axios.create({
    // baseURL: 'http://foodna-api.codebnb.me/api/v0'
    baseURL: 'https://foodna-api.codebnb.me/api/v0'
});

export default instance;



// WEBPACK FOOTER //
// ./src/http/axios.js